(function(){
    "use strict";
    
    angular
        .module("app")
        .service("certificatesService", service);

    function service($http) {
        const self = this;
        self.isLoading = false;
        self.certificates = [];

        self.refresh = () => {
            self.isLoading = true;
            return $http
                .get("/api/csos-certificates/")
                .then(result => {
                    self.certificates = result.data;
                })
                .finally(() => self.isLoading = false);
        };

        self.deleteCertificate = (certificate_id) => {
            self.isLoading = true;
            return $http
                .delete(`/api/csos-certificates/${certificate_id}`)
                .then(result => {
                    const index = self.certificates.findIndex(c => c.certificate_id === certificate_id);
                    if(index !== -1)
                        self.certificates.splice(index, 1);
                })
                .finally(() => self.isLoading = false);
        };
    }
    service.$inject = ["$http"];
    
})()